// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3baVE","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2eX1N"};